import { Toast } from "@shopify/app-bridge-react"
import {
    Card,
    Icon,
    Layout,
    Page,
    TextStyle,
    Thumbnail,
    Button,
    Checkbox,
    FormLayout,
    PageActions,
    ResourceList,
    ResourceItem,
    TextField,
    Stack,
    Spinner,
    ChoiceList,
} from "@shopify/polaris"
import { ArrowLeftMinor, ExternalMinor } from "@shopify/polaris-icons"
import React, { Component } from "react"
import axios from "../../funcs/axios"
import { DateTimePicker } from "react-rainbow-components"
import "./style.scss"
import moment from "moment"
export default class SingleProductDetail extends Component {
    state = {
        startCondition: ["now"],
        status: true,
        overSelling: ["auto"],
        product: {},
        loaded: false,
        shop: "",
        variants: "",
        selectItem: null,
        sameVariant: true,
        test: null,
        toast: {
            error: false,
            content: "",
            show: false,
        },
    }

    constructor(props: Props) {
        super(props)
        let productId = { id: props.productId }
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/load-pre-order`, productId).then((res) => {
            console.log("res", res)
            if (res.data.status == "success") {
                this.setState({ selectItem: res.data.item })
                this.setState({
                    product: res.data.item,
                    loaded: true,
                    shop: res.data.shop,
                    variants: res.data.item.variants,
                })
                this.setState({
                    toast: { show: true, content: res.data.msg, error: false },
                })
            } else {
                axios
                    .post(`${window.SHOPIFY_APP_HOST}/admin/load-product`, productId)
                    .then((res) => {
                        let product = res.data.product
                        let obj = {
                            id: product.id,
                            name: product.title,
                            handle: product.handle,
                            image: product.image,
                            message: null,
                            startCondition: { type: "now", condition: null },
                            endQuantity: { check: false, condition: "", type: "quantity" },
                            endDate: { check: false, condition: "", type: "date" },
                            countdown: { endCountdown: false },
                            requiredCondition: "auto",
                            after_finish: null,
                            discount_payment:
                                '{"fullPayment":{"enable":true,"discountValue":"10","discountType":"percentage"},"partialPayment":{"enable":true,"value":"10","valueType":"percentage","discountValue":"10","discountType":"percentage"}}',
                            status: 1,
                            created_at: new Date(),
                            updated_at: new Date(),
                            sameVariant: false,
                        }
                        let variants = []
                        // '{"type":"now","condition":null}'
                        for (let i = 0; i < product.variants.length; i++) {
                            variants.push({
                                id: product.variants[i].id,
                                name: product.variants[i].title,
                                message: null,
                                startCondition: { type: "now", condition: null },
                                endQuantity: { check: false, condition: "", type: "quantity" },
                                endDate: { check: false, condition: "", type: "date" },
                                countdown: { endCountdown: false },
                                requiredCondition: "auto",
                                after_finish: null,
                                discount_payment:
                                    '{"fullPayment":{"enable":true,"discountValue":"10","discountType":"percentage"},"partialPayment":{"enable":true,"value":"10","valueType":"percentage","discountValue":"10","discountType":"percentage"}}',
                                status: 1,
                                created_at: "2021-02-17T03:40:58.000000Z",
                                updated_at: "2021-02-17T07:14:02.000000Z",
                            })
                        }
                        obj.variants = variants
                        console.log("obj", obj)
                        this.setState({ selectItem: obj })
                        this.setState({ product: obj, loaded: true, shop: res.data.shop, variants })
                        this.setState({
                            toast: { show: true, content: res.data.msg, error: false },
                        })
                    })
                    .catch((err) => console.log(err))
            }
        })
    }

    onChangeQuantity = (val) => {
        this.setState({ startQuantity: val })
    }

    handleSaveProduct = () => {
        axios.post(`${window.SHOPIFY_APP_HOST}/admin/save-pre-order`, this.state.product).then((res) =>
            this.setState({
                toast: { show: true, content: res.data.msg, error: false },
            }),
        )
    }

    handleSelect = (item) => {
        this.setState({ selectItem: item })
    }

    handleChangeSameVariant = (check) => {
        const { product } = this.state
        product.sameVariant = check
        this.setState({ product, selectItem: product })
    }

    hanldeChange = (key, id, value) => {
        const { variants, product } = this.state
        let newProduct
        if (id == product.id) {
            newProduct = product
        } else {
            newProduct = variants.find((item) => item.id == id)
        }
        switch (key) {
            case "status":
                newProduct.status = !newProduct.status
                break
            case "startCondition": {
                if (value == "now") {
                    newProduct.startCondition.type = "now"
                }
                if (value == "date") {
                    newProduct.startCondition.type = "date"
                    newProduct.startCondition.condition = new Date()
                }
                if (value == "quantity") {
                    newProduct.startCondition.type = "quantity"
                    newProduct.startCondition.condition = "0"
                }
                break
            }
            case "startDate":
                newProduct.startCondition.condition = value
                break
            case "startQuantity":
                newProduct.startCondition.condition = value
                break
            case "requiredCondition":
                newProduct.requiredCondition = value
                break
            case "checkEndQuantity":
                newProduct.endQuantity.check = !newProduct.endQuantity.check
                newProduct.endQuantity.condition = "-10"
                break
            case "endQuantity":
                newProduct.endQuantity.condition = value
                break
            case "checkEndDate":
                newProduct.endDate.check = !newProduct.endDate.check
                let d = new Date()
                d.setDate(d.getDate() + 1)
                newProduct.endDate.condition = d
                break
            case "endDate":
                newProduct.endDate.condition = value
                break
            case "endCountdown":
                newProduct.countdown.endCountdown = !newProduct.countdown.endCountdown
                break
            default:
                break
        }
        this.setState({ selectItem: newProduct })
    }

    render() {
        const { overSelling, product, loaded, shop, variants, selectItem, toast } = this.state
        // const {
        //     status
        // } = selectItem;
        let arrayVariant = [...variants]
        let arrayProduct = []
        arrayProduct.push(product)
        const url = `https://${shop}/products/${product.handle}`
        return loaded ? (
            <div className="product-detail">
                <div
                    className="product_detail_back"
                    onClick={() => this.props.redirectToPage("SingleProduct")}
                >
                    <Icon source={ArrowLeftMinor} />
                    <span style={{ marginLeft: "10px" }}>Back to List</span>
                </div>
                <Page
                    title={selectItem.name}
                    secondaryActions={[
                        {
                            content: "View",
                            external: true,
                            icon: ExternalMinor,
                            url,
                        },
                    ]}
                >
                    <Layout>
                        <Layout.Section secondary>
                            <div className="product-detail-info">
                                <Card title="Product">
                                    <ResourceList
                                        resourceName={{ singular: "customer", plural: "customers" }}
                                        items={arrayProduct}
                                        renderItem={(item) => {
                                            const { id, name, image, handle } = item
                                            const media = (
                                                <Thumbnail
                                                    source={image.src}
                                                    // size="small"
                                                    alt={handle}
                                                />
                                            )

                                            return (
                                                <div
                                                    className={
                                                        selectItem.id == id ? "selected" :  "list-item"
                                                    }
                                                >
                                                    <ResourceItem
                                                        id={id}
                                                        media={media}
                                                        onClick={() => this.handleSelect(item)}
                                                        accessibilityLabel={`View details for ${name}`}
                                                    >
                                                        <h3>
                                                            <TextStyle variation="strong">
                                                                {name}
                                                            </TextStyle>
                                                        </h3>
                                                    </ResourceItem>
                                                </div>
                                            )
                                        }}
                                    />
                                </Card>
                                {/* Variant */}
                                {!product.sameVariant && (
                                    <Card title="Variants">
                                        <ResourceList
                                            resourceName={{
                                                singular: "customer",
                                                plural: "customers",
                                            }}
                                            items={arrayVariant}
                                            renderItem={(item) => {
                                                const { id, name, status, startCondition } = item
                                                let text = ""
                                                const media = (
                                                    <div className="default-image">
                                                        <svg
                                                            viewBox="0 0 20 20"
                                                            className="_1nZTW _2QX6Y"
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M14 9l-5 5-3-2-5 3v4h18v-6z"
                                                            />
                                                            <path d="M19 0H1a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM8 6c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.654 0 3-1.346 3-3S9.654 4 8 4 5 5.346 5 7s1.346 3 3 3zm-6 8v-2.434l3.972-2.383 2.473 1.65c.398.264.925.21 1.262-.126l4.367-4.367L18 13.48V18H2zM18 2v8.92l-3.375-2.7a.999.999 0 0 0-1.332.073l-4.42 4.42-2.318-1.545a1 1 0 0 0-1.07-.025L2 13.233V2h16z" />
                                                        </svg>
                                                    </div>
                                                )
                                                if (status) {
                                                    text = "Enable"
                                                    if (startCondition.type == "date") {
                                                        text +=
                                                            " when " +
                                                            moment(startCondition.condition).format(
                                                                "MMMM Do YYYY",
                                                            )
                                                    }
                                                    if (startCondition.type == "quantity") {
                                                        text +=
                                                            " when available quantity is " +
                                                            startCondition.condition
                                                    }
                                                } else {
                                                    text = "Disable"
                                                }

                                                return (
                                                    <div
                                                        className={
                                                            selectItem.id == id ? "selected" :  "list-item"
                                                        }
                                                    >
                                                        <ResourceItem
                                                            id={id}
                                                            // url={url}
                                                            media={media}
                                                            onClick={() => this.handleSelect(item)}
                                                            accessibilityLabel={`View details for ${name}`}
                                                        >
                                                            <h3>
                                                                <TextStyle variation="strong">
                                                                    {name}
                                                                </TextStyle>
                                                            </h3>
                                                            <div>{text}</div>
                                                        </ResourceItem>
                                                    </div>
                                                )
                                            }}
                                        />
                                    </Card>
                                )}
                            </div>
                        </Layout.Section>
                        <Layout.Section>
                            <Card>
                                <Card.Section>
                                    <div className="product-detail__action">
                                        <div>
                                            Pre-order status is{" "}
                                            <span style={{ fontWeight: "bold" }}>
                                                {selectItem.status ? "enabled." : "disable."}
                                            </span>
                                        </div>
                                        <Button
                                            destructive={selectItem.status}
                                            primary={!selectItem.status}
                                            onClick={() =>
                                                this.hanldeChange("status", selectItem.id)
                                            }
                                        >
                                            {!selectItem.status ? "Enable" : "Disable"}
                                        </Button>
                                    </div>
                                </Card.Section>
                                <Card.Section>
                                    <Checkbox
                                        label="Same pre-order settings for all variants"
                                        checked={product.sameVariant}
                                        onChange={(val) => this.handleChangeSameVariant(val)}
                                    />
                                </Card.Section>
                            </Card>

                            <Card title="Pre-order START condition">
                                <Card.Section>
                                    <ChoiceList
                                        choices={[
                                            { label: "Now", value: "now" },
                                            {
                                                label: "Start quantity (equal or less than)",
                                                value: "quantity",
                                            },
                                            { label: "Start date", value: "date" },
                                        ]}
                                        selected={selectItem.startCondition.type}
                                        onChange={(value) =>
                                            this.hanldeChange(
                                                "startCondition",
                                                selectItem.id,
                                                value,
                                            )
                                        }
                                    />
                                    {selectItem.startCondition.type == "quantity" && (
                                        <TextField
                                            type="number"
                                            value={selectItem.startCondition.condition}
                                            onChange={(value) =>
                                                this.hanldeChange(
                                                    "startQuantity",
                                                    selectItem.id,
                                                    value,
                                                )
                                            }
                                        />
                                    )}
                                    {selectItem.startCondition.type == "date" && (
                                        <DateTimePicker
                                            value={selectItem.startCondition.condition}
                                            className="date-time-picker"
                                            // label="DatePicker Label"
                                            formatStyle="large"
                                            onChange={(value) =>
                                                this.hanldeChange("startDate", selectItem.id, value)
                                            }
                                        />
                                    )}
                                </Card.Section>
                                <Card.Section title="OVERSELLING SETTINGS">
                                    <ChoiceList
                                        title={`You must enable "Continue selling when out of stock" to
                                        allow pre-ordering products when sold out`}
                                        choices={[
                                            {
                                                label: `Automatically turn on "Continue selling when out of stock" for all "Track quantity" products`,
                                                value: "auto",
                                            },
                                            {
                                                label: `Keep products' inventory setup, I will enable by myself.`,
                                                value: "none",
                                            },
                                        ]}
                                        selected={selectItem.requiredCondition}
                                        onChange={(value) =>
                                            this.hanldeChange(
                                                "requiredCondition",
                                                selectItem.id,
                                                value,
                                            )
                                        }
                                    />
                                </Card.Section>
                            </Card>

                            <Card title="Pre-order STOP conditions">
                                <Card.Section>
                                    <p>
                                        You can select multiple conditions. Pre-order will be
                                        disabled when a condition ends first. If none is selected,
                                        it will end when you manually disable it.
                                    </p>
                                </Card.Section>
                                <Card.Section title="BY INVENTORY QUANTITY">
                                    <FormLayout>
                                        <Checkbox
                                            label="Stop pre-order program when inventory quantity reach to:"
                                            checked={selectItem.endQuantity.check}
                                            onChange={() =>
                                                this.hanldeChange("checkEndQuantity", selectItem.id)
                                            }
                                        />
                                        {selectItem.endQuantity.check && (
                                            <TextField
                                                type="number"
                                                value={selectItem.endQuantity.condition}
                                                onChange={(val) =>
                                                    this.hanldeChange(
                                                        "endQuantity",
                                                        selectItem.id,
                                                        val,
                                                    )
                                                }
                                            />
                                        )}
                                    </FormLayout>
                                </Card.Section>
                                <Card.Section title="BY DATE AND TIME">
                                    <FormLayout>
                                        <Checkbox
                                            label="End date"
                                            checked={selectItem.endDate.check}
                                            onChange={(val) =>
                                                this.hanldeChange(
                                                    "checkEndDate",
                                                    selectItem.id,
                                                    val,
                                                )
                                            }
                                        />
                                        {selectItem.endDate.check && (
                                            <DateTimePicker
                                                error={
                                                    selectItem.endDate.condition
                                                        ? ""
                                                        : "Select a date is Required"
                                                }
                                                className="date-time-picker"
                                                value={selectItem.endDate.condition}
                                                // label="DatePicker Label"
                                                formatStyle="large"
                                                onChange={(val) =>
                                                    this.hanldeChange("endDate", selectItem.id, val)
                                                }
                                            />
                                        )}
                                        {selectItem.endDate.check && (
                                            <Checkbox
                                                label="Enable Countdown for End date"
                                                checked={selectItem.countdown.endCountdown}
                                                onChange={() =>
                                                    this.hanldeChange("endCountdown", selectItem.id)
                                                }
                                            />
                                        )}
                                    </FormLayout>
                                </Card.Section>
                            </Card>

                            {/* <Card title="Payment and Discount">
                                <Card.Section>
                                    <p>
                                        Discount & Partial payment feature will allow to redirect to
                                        check-out page( skip the cart page ) when purchasing
                                        pre-order products and just only 1 product could be bought
                                    </p>
                                </Card.Section>
                                <Card.Section>
                                    <p>This feature is limited. Please upgrade your plan to use</p>
                                </Card.Section>
                                <Card.Section>
                                    <FormLayout>
                                        <Checkbox
                                            label="Stop pre-order program when inventory quantity reach to:"
                                            checked={sameVariant}
                                            onChange={() =>
                                                this.setState({ sameVariant: !sameVariant })
                                            }
                                        />
                                        <div>
                                            <Button>Discount</Button>
                                            <TextField
                                                type="number"
                                                value="-10"
                                                onChange={() => {}}
                                            />
                                        </div>
                                        <Checkbox
                                            label="Partial payment"
                                            checked={sameVariant}
                                            onChange={() =>
                                                this.setState({ sameVariant: !sameVariant })
                                            }
                                        />
                                    </FormLayout>
                                </Card.Section>
                            </Card> */}
                        </Layout.Section>
                    </Layout>
                    <PageActions
                        primaryAction={{
                            content: "Save",
                            onAction: () => this.handleSaveProduct(),
                        }}
                    />
                </Page>
                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        ) : (
            <Stack distribution="center">
                <div style={{ marginTop: "20px", display: "flex" }}>
                    <Spinner
                        accessibilityLabel="Loading more customers"
                        size="large"
                        color="teal"
                    />
                </div>
            </Stack>
        )
    }
}
